// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import 'element-ui/lib/theme-chalk/index.css';
import InfoInput from '@/components/basic/InfoInput';
import TextButton from '@/components/basic/TextButton';
import DropdownSelect from '@/components/DropdownSelect';
import PopWindow from '@/plugins/PopWindow';
import Tooltip from '@/plugins/tooltip';
import CustomNotification from '@/plugins/CustomNotification';
import dropdown from '@/plugins/dropdown';
import request from '@/api/request';
import authApi from '@/api/auth';
import BFOPMixin from '@/store/BFOPMixin';
import 'es6-promise/auto';
import ELEMENT from 'element-ui';
import CommonModules from 'common-modules-zj';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import VueI18n from 'vue-i18n';
import checkSSO from '@/utils/js/checkSSO';
import router from './router/index';
import store from './store';
import App from './App';

import messages from './i18n';
import misc from './utils/js/misc';

import './assets/styles/common.scss';

Vue.config.productionTip = false;

Vue.use(ELEMENT);

Vue.use(VueCookie);
Vue.use(VueI18n);

Vue.use(request);
Vue.use(authApi);

Vue.component('emoti-icon', CommonModules.EmotiIcon);
Vue.component('emoti-panel', CommonModules.EmotiPanel);
Vue.component('emoti-page-header', CommonModules.PageHeader);
Vue.component('emoti-product-menu', CommonModules.ProductMenu);
Vue.component('emoti-page-menu', CommonModules.PageMenu);
Vue.component('emoti-card', CommonModules.EmotiCard);
Vue.component('emoti-common-tree', CommonModules.CommonTree);

Vue.use(dropdown);
Vue.use(PopWindow);
Vue.use(Tooltip);
Vue.use(CustomNotification);

Vue.component('info-input', InfoInput);
Vue.component('text-button', TextButton);
Vue.component('dropdown-select', DropdownSelect);
Vue.mixin(BFOPMixin);

let locale = localStorage.getItem('locale');
if (!locale) {
  locale = misc.getBrowserLanguage();
}
locale = misc.checkLanguage(locale);
localStorage.setItem('locale', locale);

const i18n = new VueI18n({
  locale,
  messages,
  silentTranslationWarn: true,
});

ELEMENT.i18n((key, value) => i18n.t(key, value));
/* eslint-disable no-new */
checkSSO().finally(() => {  // @:当单点登录的触发页面就是此工程时, sso接口会重定向走到这里, 因此此处也需要校验SSO信息
  new Vue({
    el: '#app',
    template: '<App/>',
    i18n,
    store,
    components: {
      App,
    },
    router,
  });
});



// WEBPACK FOOTER //
// ./src/main.js